import * as React from 'react'
import * as AppStore from './../state/app-store'
import { useForm } from '@mantine/form'
import { useMutation } from '@apollo/client'
import {
	Alert,
	Button,
	Flex,
	Loader,
	PasswordInput,
	TextInput,
} from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'
import * as NextRouter from 'next/router'

import * as Types from 'declarations'
import * as GQLQueries from '../lib/queries'

import * as Actions from './../state/actions'

const LoginForm = ({ onLogin }: { onLogin: () => void }) => {
	const [errorDisplay, setErrorDisplay] = React.useState<string>('')
	// todo: redundant?
	// const [isRedirecting, setIsRedirecting] = React.useState<boolean>(false)

	const dispatch = AppStore.useAppDispatch()
	const router = NextRouter.useRouter()

	const form = useForm({
		initialValues: {
			email: '',
			password: '',
		},
		validate: {
			email: (value) =>
				!value
					? 'Email is required'
					: !/^\S+@\S+$/.test(value)
					? 'Invalid email'
					: null,
			password: (value) => !value && 'Password is required',
		},
		validateInputOnBlur: true,
		validateInputOnChange: true,
	})

	const [login, { error, loading: isLoading }] = useMutation(
		GQLQueries.Mutations.LOGIN,
	)

	const handleSubmit = async (values: { email: string; password: string }) => {
		setErrorDisplay('')
		const response = await login({ variables: values })

		const { user, token } = response?.data?.login

		if (user) {
			dispatch(Actions.attemptLoginSucceeded(token, user))

			// raise parent event
			onLogin()

			if (user.role === Types.App.DataTypes.UserRole.GUIDE) {
				router.push('/guide')
			}
		}
		if (response?.data?.login?.error) {
			setErrorDisplay(response.data.login.error)
		}
	}

	const displayError = error?.message || errorDisplay || undefined

	return (
		<form onSubmit={form.onSubmit((values) => handleSubmit(values))}>
			<Flex gap="xs" justify="flex-start" direction="column" pt="md">
				<TextInput
					label="Email"
					type="email"
					required
					{...form.getInputProps('email')}
					// placeholder={'the email address you signed up with'}
				/>
				<PasswordInput
					label="Password"
					required
					{...form.getInputProps('password')}
				/>
				<Button type="submit" mt="lg" disabled={isLoading || !form.isValid()}>
					{isLoading ? (
						<>
							Logging in&nbsp;&nbsp;&nbsp;
							<Loader size="sm" variant="dots" color="gray" />
						</>
					) : (
						'Log in'
					)}
				</Button>
				{displayError && (
					<Alert
						icon={<IconAlertCircle size="1rem" />}
						title="Something went wrong"
						color="red"
					>
						{displayError}
					</Alert>
				)}
			</Flex>
		</form>
	)
}

export default LoginForm
